import { Component, OnInit } from '@angular/core';
import { tabs } from '../../data/static/SelfEnrolTabs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit {
  tabs = [];
  agree = false;

  constructor(private router: Router) { }

  ngOnInit() {
    this.tabs = tabs;
  }

  next() {
    this.router.navigate(['/selfEnroll/serviceAndTerms']);
  }

}
